import { render, staticRenderFns } from "./FeatureFlags.vue?vue&type=template&id=15ceeb52&"
import script from "./FeatureFlags.vue?vue&type=script&lang=js&"
export * from "./FeatureFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports